import { createContext, useContext, useMemo } from 'react'
import { teams as teamApi } from '@/api/endpoints'
import type { TeamInvitation } from '@/api/types'
import { usePoll } from '@/hooks/usePoll'

// 내게 온, 답을 기다리는 팀 초대(F-92). 사용자 껍데기의 상단 바 표시와 팀 화면이 **한 번의 읽기**를 나눠 본다 —
// 팀 화면에서 수락·거절하면 상단 바의 수도 그 자리에서 준다. 스트림은 최고 관리자의 것이라 폴링만 한다.
// Provider 는 App 의 사용자 껍데기다.
const INVITES_POLL_MS = 15000

export type InvitesRead = { list: TeamInvitation[] | null; error: Error | null; refresh: () => void }

export const InvitesCtx = createContext<InvitesRead>({ list: null, error: null, refresh: () => undefined })

export function useInvites(): InvitesRead {
  return useContext(InvitesCtx)
}

/** 껍데기가 한 번 부르는 읽기. 화면은 `useInvites` 로 그 값을 본다. */
export function useInvitesPoll(): InvitesRead {
  const poll = usePoll(teamApi.myInvitations, INVITES_POLL_MS)
  const { data, error, refresh } = poll
  return useMemo(() => ({ list: data, error, refresh }), [data, error, refresh])
}
